import { colors, fonts, screen } from 'components/styles/variables';
import css from 'styled-jsx/css';
import websiteIconRed from 'public/static/images/vdp/website-icon-red.svg';
import phoneIconRed from 'public/static/images/vdp/call-icon-red.svg';
import emailIconRed from 'public/static/images/vdp/email-icon-red.svg';
import hoverShareIcon from 'public/static/images/vdp/hover-share.svg';

export const actionCss = css`
  .action-button {
    background: none;
    border: none;
    padding: 0;
    display: pointer;
    display: flex;
    align-items: center;
    font-family: ${fonts.default};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: ${colors.BLACK};
    text-decoration: none;
  }
  .icon {
    width: 30px;
    height: 30px;
  }
  .actions-list-item {
    list-style: none;
  }
  .actions-list-item > button:hover,
  .actions-list-item > a:hover,
  .actions-list-item > span:hover {
    color: ${colors.ALR1};
    text-decoration: underline;
  }
  .title {
    margin-left: 12px;
    display: none;
  }
  @media screen and (min-width: ${screen.lgMin}) {
    .title {
      display: block;
    }
  }
  .actions {
    padding: 0;
    margin: 0;
    display: flex;
  }

  .actions-list-item + .actions-list-item {
    margin-left: 16px;
  }

  @media screen and (min-width: ${screen.lgMin}) {
    .actions-list-item + .actions-list-item {
      margin-left: 32px;
    }
  }
  .share-container {
    position: relative;
  }
  .share-dropdown {
    display: none;
    position: absolute;
    left: -25px;
    top: 26px;
  }
  @media (min-width: ${screen.lgMin}) {
    .share-container:hover .share-dropdown {
      display: block;
    }
  }
  .action-button:hover .website-icon {
    content: url(${websiteIconRed});
  }
  .action-button:hover .phone-icon {
    content: url(${phoneIconRed});
  }
  .action-button:hover .email-icon {
    content: url(${emailIconRed});
  }
  .action-button:hover .share-icon {
    content: url(${hoverShareIcon});
  }
`;
